<template>
  <nav class="kt-datatable__pager kt-datatable--paging-loaded">
    <ul class="kt-datatable__pager-nav">
      <li>
        <a title="First"
           :class="{
             'kt-datatable__pager-link--disabled': current_page === 1
           }"
           class="kt-datatable__pager-link kt-datatable__pager-link--first"
           @click="setPage(1)">
          <i class="flaticon2-fast-back" />
        </a>
      </li>
      <li>
        <a title="Previous"
           class="kt-datatable__pager-link kt-datatable__pager-link--prev"
           :class="{
             'kt-datatable__pager-link--disabled': current_page === 1
           }"
           :disabled="current_page === 1"
           @click="setPage(current_page - 1)">
          <i class="flaticon2-back" />
        </a>
      </li>
      <li v-if="current_page >= 7" id="pagination-pre-ellipsis" class="pagination-ellipsis">
        ...
      </li>
      <li v-for="index in Array.from(Array(12).keys()).map(k => k + current_page - 6).filter(k => k >= 1 && k <= page_count)"
          :key="index">
        <a href="javascript:void(0);"
           role="button"
           class="kt-datatable__pager-link kt-datatable__pager-link-number"
           :class="{
             'kt-datatable__pager-link--active': index === current_page
           }"
           @click="setPage(index)">
          {{ index }}
        </a>
      </li>
      <li v-if="current_page <= page_count - 7" id="pagination-post-ellipsis" class="pagination-ellipsis">
        ...
      </li>
      <li>
        <a title="Next"
           class="kt-datatable__pager-link kt-datatable__pager-link--next"
           :class="{
             'kt-datatable__pager-link--disabled': current_page >= page_count
           }"
           @click="setPage(current_page + 1)">
          <i class="flaticon2-next" />
        </a>
      </li>
      <li>
        <a title="Last"
           class="kt-datatable__pager-link kt-datatable__pager-link--last"
           :class="{
             'kt-datatable__pager-link--disabled': current_page >= page_count
           }"
           @click="setPage(page_count)">
          <i class="flaticon2-fast-next" />
        </a>
      </li>
    </ul>
    <div class="kt-datatable__pager-info">
      <div class="dropdown bootstrap-select kt-datatable__pager-size" style="width: 60px;">
        <input type="number"
               :min="1"
               :max="totalRows"
               :value="maxPageSize"
               class="pagination-per-page-input form-input"
               @change="updateMaxPageSize">
      </div>
      <span class="kt-datatable__pager-detail">
        Showing
        <span v-if="currentSlice.end <= totalRows || currentSlice.start < totalRows - 1">{{ currentSlice.start }} - {{ Math.min(currentSlice.end, totalRows) }}</span>
        <span v-else>{{ totalRows }}</span>
        of {{ totalRows }}
      </span>
    </div>
    <b-popover v-if="current_page >= 7" placement="bottom"
               target="pagination-pre-ellipsis"
               triggers="hover">
      <div class="goto-popup">
        <label for="goto-page">
          Jump to page:
        </label>
        <input type="number" name="goto-page" @change="event => setPage(event.target.value)">
      </div>
    </b-popover>
    <b-popover v-if="current_page <= page_count - 7" placement="bottom"
               target="pagination-post-ellipsis"
               triggers="hover">
      <div class="goto-popup">
        <label for="goto-page">
          Jump to page:
        </label>
        <input type="number" name="goto-page" @change="event => setPage(event.target.value)">
      </div>
    </b-popover>
  </nav>
</template>

<script>
import { BPopover } from 'bootstrap-vue';

export default {
  components: {
    BPopover,
  },
  props: {
    totalRows: {
      required: true,
      type: Number,
    },
    maxPageSize: {
      required: true,
      type: Number,
    },
    pageCount: {
      required: false,
      type: Number,
      default: -1,
    },
    currentSlice: {
      required: true,
      type: Object,
      validator: (val) => {
        if (val === undefined || val === null || val && typeof val !== 'object') {
          console.error(`not obj or not def`);
          return false;
        }
        if (val.start === undefined || val.start === null || val.start && typeof val.start !== 'number') {
          console.error(`not def or not num start`);
          return false;
        }
        if (val.start === undefined || val.start === null || val.end && typeof val.end !== 'number') {
          console.error(`not def or not num end`);
          return false;
        }
        return true;
      },
    },
    initialPage: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      current_page: this.initialPage,
    };
  },
  computed: {
    page_count() {
      return this.pageCount === -1 ? Math.ceil(this.totalRows / this.maxPageSize) : this.pageCount;
    },
  },
  methods: {
    setPage(which) {
      this.current_page = Math.max(1, Math.min(which, this.page_count));
      this.$emit(`pagination-page-change`, this.current_page);
    },
    updateMaxPageSize(event) {
      this.$emit(`pagination-perpage-change`, event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.pagination-ellipsis {
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 4px !important;
  font-size: 1.2em;
}

.goto-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pagination-per-page-input {
  width: 4em;
  text-align: center;
}

%pagination-a-hover {
  color: #fff !important;
  background-color: map.get($ss-adds, 'primary-hover') !important;
}

.kt-datatable__pager-nav {
  a {
    color: var(--dark) !important;

    &:hover {
      @extend %pagination-a-hover;
    }

    &.kt-datatable__pager-link--active {
      background-color: map.get($ss, 'primary') !important;
      color: #fff !important;

      &:hover {
        @extend %pagination-a-hover;
      }
    }
  }
}
</style>
